import { rgb } from '../helpers';
import { GREY, GARGOYLE_GREY, WHITE, SKY_BLUE } from '../theme/color';

export const overrides = {
    MuiTooltip: {
        tooltip: {
            color: GREY,
            borderColor: GARGOYLE_GREY,
            backgroundColor: WHITE,
            boxShadow: `0 1px 2px 0 rgba(${rgb(
                SKY_BLUE
            )}, 0.06), 0 3px 5px 0 rgba(${rgb(SKY_BLUE)}, 0.12)`
        },
        arrow: {
            '&::before': {
                backgroundColor: WHITE,
                borderColor: GARGOYLE_GREY
            }
        }
    }
};
